jQuery(function($){
    function initFooterAccordion() {
        if ($(window).width() < 750) {
            // Enable accordion only on mobile
            $('.footer-block__details-content').hide(); // hide all first
            $('.footer-block__heading').first().addClass('active');
            $('.footer-block__details-content').first().addClass('open').slideDown(0);

            $('.footer-block__heading').off('click.footerAccordion').on('click.footerAccordion', function() {
                $(this).toggleClass('active');
                $(this).next('.footer-block__details-content').slideToggle(300, function() {
                    $(this).toggleClass('open', $(this).is(':visible'));
                });
            });
        } else {
            // Disable accordion on desktop
            $('.footer-block__heading').off('click.footerAccordion').removeClass('active');
            $('.footer-block__details-content').show().addClass('open').removeAttr('style');
        }
    }

    // Run on load
    initFooterAccordion();

    // Run on resize
    $(window).on('resize', function() {
        initFooterAccordion();
    });
});